module.exports = __webpack_public_path__ + "static/media/jeremy-yap.fcc0c0f7.jpg";